export default function EFXFusion(props: any) {
    return (
        <svg width="320" height="67" viewBox="0 0 320 67" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M100.883 40.9644H107.276L110.628 28.4603H139.582L141.344 21.9023H105.991L100.883 40.9644Z" fill="currentColor" />
            <path d="M107.59 15.9544H142.937L144.692 9.39648H109.345L107.59 15.9544Z" fill="currentColor" />
            <path
                d="M171.314 34.6076H149.102L155.831 9.42188H149.261L142.44 34.8706C141.535 38.2536 143.541 40.9881 146.918 40.9881H176.153L184.614 9.42188H178.044L171.314 34.6076Z"
                fill="currentColor"
            />
            <path
                d="M271.207 9.39648H250.505C246.456 9.39648 242.29 12.6816 241.201 16.7375L236.68 33.6279C235.591 37.6776 237.995 40.9688 242.051 40.9688H262.753C266.802 40.9688 270.968 37.6838 272.057 33.6279L276.578 16.7375C277.667 12.6816 275.263 9.39648 271.207 9.39648ZM265.793 33.1629C265.588 33.8599 264.965 34.3508 264.239 34.3864H244.082C243.777 34.4019 243.485 34.2627 243.305 34.016C243.125 33.7694 243.081 33.4487 243.189 33.1629L247.471 17.1963C247.679 16.5015 248.301 16.012 249.025 15.9728H269.213C269.518 15.9573 269.81 16.0966 269.99 16.3432C270.17 16.5898 270.214 16.9106 270.106 17.1963L265.793 33.1629Z"
                fill="currentColor"
            />
            <path d="M222.211 40.9627H228.604L237.064 9.39648H230.665L222.211 40.9627Z" fill="currentColor" />
            <path
                d="M192.25 21.9006L193.841 15.9544H222.813L224.569 9.39648H195.334C191.957 9.39648 188.482 12.1371 187.577 15.514L184.108 28.4892H213.08L211.484 34.4354H182.511L180.762 40.9872H209.991C213.374 40.9872 216.843 38.2527 217.748 34.8697L221.217 21.9251L192.25 21.9006Z"
                fill="currentColor"
            />
            <path
                d="M313.429 9.39648L307.452 31.7131L291.369 9.39648H291.216H284.646L276.191 40.9627H282.762L288.738 18.6461L304.821 40.9627H307.018H311.544L319.999 9.39648H313.429Z"
                fill="currentColor"
            />
            <path d="M80.1836 28.4899H97.8449L99.6005 21.9258H81.9454L80.1836 28.4899Z" fill="currentColor" />
            <path d="M43.0676 0.863281H25.2656L40.8162 21.9074L52.1703 13.1961L43.0676 0.863281Z" fill="currentColor" />
            <path d="M61.2246 49.5021H79.0327L64.7605 30.1953L52.4766 37.6648L61.2246 49.5021Z" fill="currentColor" />
            <path
                d="M95.3411 0.863281H72.9694L34.2824 30.5392H42.7552L0 66.4183L73.2385 21.9319H64.6741L95.3411 0.863281Z"
                fill="url(#paint0_linear_11810_17838)"
            />
            <defs>
                <linearGradient id="paint0_linear_11810_17838" x1="90.0677" y1="0.863281" x2="0.111614" y2="66.311" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#EAC64C" />
                    <stop offset="0.554786" stopColor="#C09325" />
                    <stop offset="1" stopColor="#AF7D14" />
                </linearGradient>
            </defs>
        </svg>
    );
}
